const NotFound = () => import('@/components/NotFound');

const NotFound404 = {
  path: '/404',
  component: NotFound,
  meta: { type: 'sso' }
};

const NotFoundWildCard = {
  path: '*',
  component: NotFound,
  meta: { type: 'sso' }
};

export { NotFoundWildCard, NotFound404 };
